import styled from 'styled-components';
import { darken } from 'polished';

export const Container = styled.section`
  flex: 6;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  padding: 5px;
  border-radius: ${({ theme }) => theme.metrics.radius};
  background-color: ${({ theme }) => darken(0.05, theme.colors.background)};

  table {
    width: 100%;
    height: fit-content;
    font-size: 11px;
    border-radius: ${({ theme }) => theme.metrics.innerRadius};
    border-collapse: collapse;
    overflow: hidden;

    thead {
      tr {
        background-color: ${({ theme }) => darken(0.1, theme.colors.background)};
        color: ${({ theme }) => theme.colors.textBackground};

        th {
          padding: 5px;
          text-transform: uppercase;
          text-align: left;
        }
      }
    }

    tbody {
      tr {
        height: 30px;
        background-color: ${({ theme }) => theme.colors.background};
        transition: 0.2s;
        cursor: pointer;

        &:nth-child(odd) {
          background-color: ${({ theme }) => darken(0.025, theme.colors.background)};

          td {
            &.feriado {
              background-color: ${({ theme }) => darken(0.025, theme.colors.error)};
            }
          }
        }

        td {
          padding: 5px;
          font-size: 12px;
          color: ${({ theme }) => theme.colors.textBackground};

          &.feriado {
            background-color: ${({ theme }) => theme.colors.error};
          }
        }

        &:hover {
          background-color: ${({ theme }) => darken(0.05, theme.colors.background)};

          td {
            &.feriado {
              background-color: ${({ theme }) => darken(0.05, theme.colors.error)};
            }
          }
        }

        &.planejamento {
          td {
            color: ${({ theme }) => theme.colors.error};
          }
        }
      }
    }
  }

  @media (max-width: ${({ theme }) => theme.metrics.tablet_small}) {
    min-width: 100%;
    max-height: calc(100vh - 80px);
  }
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.metrics.gap};
  padding: ${({ theme }) => theme.metrics.padding};
  border-radius: ${({ theme }) => theme.metrics.innerRadius};
  background-color: ${({ theme }) => theme.colors.primary};
`;

export const Title = styled.h1`
  margin-left: ${({ theme }) => theme.metrics.margin};
  margin-right: auto;
  white-space: nowrap;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 20px;
  gap: 10px;
  border-radius: ${({ theme }) => theme.metrics.innerRadius};
  border: 1px solid ${({ theme }) => darken(0.1, theme.colors.background)};
`;

export const Name = styled.h2`
  margin-bottom: 10px;
  font-size: 22px;
  font-weight: normal;
  color: ${({ theme }) => theme.colors.textBackground};
`;

export const Item = styled.div`
  display: flex;
  gap: 5px;
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

  & > :not(:first-child) {
    margin-left: 10px;
    display: list-item;
    list-style-type: disc;
    list-style-position: inside;
  }
`;

export const Key = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: ${({ theme }) => darken(0.1, theme.colors.textBackground)};
`;

export const Value = styled.div`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.textBackground};
`;
